import { formatGroupTitle } from "./formatGroupTitle";
import { getGroupPageLink } from "../utilities/getGroupPageLink";
export function getGroupDetails(groupName) {
    const group = window.groups[groupName];
    const groupDetails = {
        groupLink: getGroupPageLink(groupName),
        groupTitle: formatGroupTitle(groupName),
        groupEmail: `${groupName.replaceAll(" ", "").toLowerCase()}@cedarparkchurchofchrist.org`,
        familyCount: group.length,
        memberCount: 0,
        memberEmails: "",
        groupLeaders: [],
    };
    group.forEach((family) => {
        const familyMembers = family.members;
        groupDetails.memberCount += familyMembers.length;
        familyMembers.forEach((member) => {
            if (member.email &&
                groupDetails.memberEmails.indexOf(member.email) === -1) {
                groupDetails.memberEmails += groupDetails.memberEmails
                    ? ", "
                    : "";
                groupDetails.memberEmails += member.email;
            }
            if (member.groups.indexOf("Deacons") > -1 ||
                member.groups.indexOf("Elders") > -1) {
                groupDetails.groupLeaders.push(member);
            }
        });
    });
    return groupDetails;
}
